export const LOOKUPS_LOADRELATIONSHIPS_SUCCESS = 'LOOKUPS_LOADRELATIONSHIPS_SUCCESS';
export const LOOKUPS_LOADCOUNTRIES_SUCCESS = 'LOOKUPS_LOADCOUNTRIES_SUCCESS';
export const LOOKUPS_LOADPREFERREDCOMMUNICATIONS_SUCCESS = 'LOOKUPS_LOADPREFERREDCOMMUNICATIONS_SUCCESS';
export const LOOKUPS_LOADSTATES_SUCCESS = 'LOOKUPS_LOADSTATES_SUCCESS';
